import axios from "axios";
import { DacSessionResponse } from '../../../common/types/digitalAccountCheck';

const {
  REACT_APP_DAC_INIT_SESSION_URL,
} = process.env;

export const initializeDacSession = async (transactionId: string): Promise<DacSessionResponse> => {
  const response = await axios.post(`${REACT_APP_DAC_INIT_SESSION_URL}/${transactionId}`,);
  return response.data;
};
